import { render, staticRenderFns } from "./QuizTaskViewer.vue?vue&type=template&id=1b58161c&"
import script from "./QuizTaskViewer.vue?vue&type=script&lang=js&"
export * from "./QuizTaskViewer.vue?vue&type=script&lang=js&"
import style0 from "./QuizTaskViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports